export default "__VITE_ASSET__2d01a023__"